// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"00cdd3d8","195":"f24257fe","205":"26a180d9","274":"b46c3cdc","353":"6699f368","546":"75843d38","678":"33eb4dd5","744":"83518688","885":"7589ca0a","963":"68cb748a"}[chunkId] + ".chunk.js";
};